module.exports = __webpack_public_path__ + "img/0Q3A2940_L_WoodMatted.cd74471e.jpg";